import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Injectable()
export class PeriodsService {
  constructor(private translate: TranslateService) {

  }

  getYears() {
    return [
      '2010', '2011', '2012',
      '2013', '2014', '2015',
      '2016', '2017', '2018',
    ];
  }

  getMonths() {
    return [
      this.translate.instant(marker('Jan')), 
      this.translate.instant(marker('Feb')), 
      this.translate.instant(marker('Mar')),
      this.translate.instant(marker('Apr')), 
      this.translate.instant(marker('May')), 
      this.translate.instant(marker('Jun')),
      this.translate.instant(marker('Jul')), 
      this.translate.instant(marker('Aug')), 
      this.translate.instant(marker('Sep')),
      this.translate.instant(marker('Oct')), 
      this.translate.instant(marker('Nov')), 
      this.translate.instant(marker('Dec')),
    ];
  }

  getWeeks() {
    return [
      this.translate.instant(marker('Mon')),
      this.translate.instant(marker('Tue')),
      this.translate.instant(marker('Wed')),
      this.translate.instant(marker('Thu')),
      this.translate.instant(marker('Fri')),
      this.translate.instant(marker('Sat')),
      this.translate.instant(marker('Sun')),
    ];
  }
}
